import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getAirServiceProductList(params) {
  return request({
    url: URL.mdm.basicData.airServiceProduct,
    method: 'get',
    params
  })
}

export function getAirServiceProductsByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformAirServiceProduct,
    method: 'get',
    params
  })
}

export function getAllAirServiceProductTemplate(params) {
  return request({
    url: URL.mdm.basicData.airServiceProductTemplate,
    method: 'get',
    params
  })
}

export function saveAirServiceProduct(data) {
  return request({
    url: URL.mdm.basicData.airServiceProduct,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addAirServiceProductByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformAirServiceProduct,
    method: 'post',
    data
  })
}

export function saveAirServiceProducts(data) {
  return request({
    url: URL.mdm.basicData.airServiceProducts,
    method: 'post',
    data
  })
}

export function delAirServiceProduct(data) {
  return request({
    url: URL.mdm.basicData.airServiceProduct,
    method: 'delete',
    data
  })
}
